import { FC } from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import { DataTree } from '../types';
import { useSearchStore } from '../stores/search';

interface AccordionSectionProps {
  categoriesData: DataTree[];
  scrollToResult: () => void;
}

export const AccordionSideBar: FC<AccordionSectionProps> = (
  {
    categoriesData,
    scrollToResult,
  }): JSX.Element => {
  const setCurrentCategoryName = useSearchStore((state) => state.setCurrentCategoryName)
  const currentCategoryId = useSearchStore((state) => state.currentCategoryId)
  const setCurrentCategoryId = useSearchStore((state) => state.setCurrentCategoryId)
  
  const setSearchQueryInput = useSearchStore((state) => state.setSearchQueryInput)
  const setAlphabetSearchCharacter = useSearchStore((state) => state.setAlphabetSearchCharacter);
  
  if (!categoriesData) {
    return <div>Loading...</div>;
  }

  const removeSearchQuery = (): void => {
    setSearchQueryInput('');
    setCurrentCategoryName('Изследвания и цени')
    setAlphabetSearchCharacter('')
  };
  
  return (
    <Accordion.Root className="" type={'multiple'}>
      {categoriesData.map((mainCategoryItem, mainCategoryIndex) => (
        <Accordion.Item  className="category-nav-link" key={mainCategoryIndex} value={mainCategoryItem.name}>
          <div id={`cb-${mainCategoryItem.id}`} onClick={() => {
            removeSearchQuery();
            setCurrentCategoryId(mainCategoryItem.id);
            setCurrentCategoryName(mainCategoryItem.name)
            scrollToResult()
          }}
            className={`w-full active:opacity-70 opacity-100 transition-opacity duration-300 flex items-center justify-between border-b ${currentCategoryId === mainCategoryItem.id ? 'price-nav-linkActive' : ''}`}>
            <div  className={`price-nav-link smarch-util w-button text-left w-full  ${currentCategoryId === mainCategoryItem.id ? 'price-nav-linkActive' : ''}`}>
              {mainCategoryItem.name}
            </div>
            <Accordion.Trigger
              className="radix-state-open:rotate-180  transition-all transform duration-100 ease-in-out">
            </Accordion.Trigger>
          </div>
          
          <Accordion.Content
            className="sub-nav-nested-collection accordion-content radix-state-open:opacity-100 opacity-0 transform transition duration-1000">
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  );
};
